<template>
  <div>
    <Container class="container-sm-none">
      <Progressbar :step="childrenWithIndexes.length > 0 ? 13 : 10" :step-count="model.stepCount">
        Documents
      </Progressbar>
      <Card class="card-shadow">
        <div class="width-lg">
          <div class="pl-10 pl-md-0 pr-10 pr-md-0">
            <DocumentComponent
              v-for="(personWithAttachments, index) in personsWithRequiredAttachments"
              ref="person"
              :key="index + 1"
              :person="personWithAttachments.person"
              :model="model"
              :errors="errors"
              :required-attachments="personWithAttachments.requiredAttachments"
              :personIndex="personWithAttachments.personIndex"
            />

            <ButtonGroup class="pt-20">
              <Button
                class="btn-outline-tertiary w-full"
                :icon-left="require('@/assets/svg/icon-left-gray.svg')"
                @click="redirectBack"
              >
                Back
              </Button>
              <Button
                class="btn-primary w-full"
                :icon-right="require('@/assets/svg/icon-right-white.svg')"
                @click="redirectToNext"
                v-scroll-to-error
              >
                Continue
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </Card>
    </Container>
  </div>
</template>
<script>
import Container from '@/components/Container/Container.vue';
import Progressbar from '@/components/Progressbar/Progressbar.vue';
import Card from '@/components/Card/Card.vue';
import ButtonGroup from '@/components/ButtonGroup/ButtonGroup.vue';
import Button from '@/components/Button/Button.vue';
import routes from '@/mixins/routes';
import DocumentComponent from '@/pagesComponents/DocumentComponent.vue';
import enums from '@/mixins/enums';
import lead from '@/mixins/lead';
import GA from '@/mixins/GA';

export default {
  name: 'DocumentPage',
  components: {
    DocumentComponent,
    ButtonGroup,
    Card,
    Progressbar,
    Container,
    Button,
  },
  mixins: [routes, enums, lead, GA],
  props: {
    errors: { type: Array, required: true },
    model: { type: Object, required: true },
  },
  created() {
    this.model.step = 19;
    if (this.model.lastStep < 19) this.model.lastStep = 19;
  },
  methods: {
    redirectToNext() {
      if (this.errors.length === 0) {
        this.saveLead(this.getNearestNextAvailableStep());
        if (!this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.includes(this.getNearestNextAvailableStep())) {
          this.model.insuredPersons.array_hd7ov6$_0[this.model.currentPersonIndex].visitedSteps.array_hd7ov6$_0.push(this.getNearestNextAvailableStep());
        }
        this.model.currentPersonStepIndex += 1;
        this.$router.goToStep(this.getNearestNextAvailableStep());
      }
    },
    redirectBack() {
      this.$router.goToStep(this.getNearestPreviousAvailableStep());
    },
  },
  computed: {
    insuredPersons() { return this.model.insuredPersons.array_hd7ov6$_0; },
    personsWithRequiredAttachments() {
      if (this.model.step < 4) return [];

      const { getRequiredAttachmentTypes_9lplti$ } = this.$kotlin.attachments;
      return this.insuredPersons
        .map((person, index) => {
          const { array_hd7ov6$_0 } = getRequiredAttachmentTypes_9lplti$(person, this.model);
          return { requiredAttachments: array_hd7ov6$_0, person, personIndex: index };
        })
        .filter((personWithAttachment) => personWithAttachment.requiredAttachments?.length);
    },
  },
  mounted() {
    this.funnelStep('Dokumenty');
  },
};
</script>
